import { _ } from "../../core/polyglot/polyglot.js";
import {
	formatAsMonth,
	formatAsMonthAndYear,
} from "../../core/helpers/date-formatting-util.js";
import Period from "./Period.js";

/**
 * `Bimester` is a period representing two months.
 * Instances should not be created by hand, but rather looked up
 * from `FiscalYear`.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} twoMonth
 */
export default class Bimester extends Period {
	constructor(spec) {
		super(spec);
		this._periodId = `B${this.getPeriodIndex()}`;
	}

	setYear(fiscalYear) {
		this._year = fiscalYear;
	}

	isBimester() {
		return true;
	}

	getName() {
		if (this._year && !this._year.isBroken()) {
			return this._asMonthsString();
		}

		return this._getMonthsAndYearName();
	}

	getGroupLabel() {
		return _("Bimesters");
	}

	toSmartString() {
		return this._getMonthsAndYearName();
	}

	_getMonthsAndYearName() {
		if (this._start.getFullYear() === this._end.getFullYear()) {
			return this._asMonthsAndEndYearString();
		}

		return this._asMonthsAndYearsString();
	}

	_asMonthsString() {
		return `${formatAsMonth(this._start)} - ${formatAsMonth(this._end)}`;
	}

	_asMonthsAndEndYearString() {
		return `${formatAsMonth(this._start)} - ${formatAsMonthAndYear(
			this._end,
		)}`;
	}

	_asMonthsAndYearsString() {
		return `${formatAsMonthAndYear(this._start)} - ${formatAsMonthAndYear(
			this._end,
		)}`;
	}

	static getType() {
		return "Bimester";
	}
}
